import React from "react";
import style from "./style.module.css";
import { selectors as ListingsReducerSelectors } from "../../../../redux/slices/v2/ListingReducer";
import { useSelector } from "react-redux";
import ProIcon from "components/Navbarv2/assets/ProIcon";
import formatUrl from "utils/FormatUrl";
import useTranslation from "next-translate/useTranslation";

function index({
  title,
  text,
  btn_text,
  t,
  reason,
  icon,
  vendre,
  offrepro,
  destinationUrl,
}: {
  title: string;
  text: string;
  btn_text: string;
  t: any;
  reason: string;
  icon: any;
  vendre?: boolean;
  offrepro?: boolean;
  destinationUrl?: string;
}) {
  const searchPayload = useSelector(
    ListingsReducerSelectors.searchPayloadSelector
  );
  const { lang } = useTranslation("");
  return (
    <div className={style.alertContainer}>
      <div>
        {offrepro ? (
          <p className={style.offreProTitle}>
            <svg
              width="24"
              height="22"
              viewBox="0 0 24 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.43437 4.61487L9.43401 4.61536C8.66452 5.66189 8.06535 6.45788 7.64276 6.99105C7.43322 7.25542 7.25697 7.46806 7.12015 7.61721C7.05451 7.68877 6.97949 7.76615 6.90323 7.83007C6.86765 7.8599 6.80434 7.91031 6.72207 7.95442C6.72122 7.95488 6.72022 7.95542 6.71908 7.95604C6.67771 7.97846 6.44541 8.10433 6.14506 8.038C6.09091 8.02635 6.05171 8.01245 6.03753 8.00742L6.03739 8.00737C6.00638 7.99637 5.98026 7.98523 5.96288 7.97751C5.92766 7.96186 5.89366 7.94473 5.86601 7.93032C5.80897 7.90059 5.74043 7.86225 5.66642 7.81963C5.51645 7.73327 5.31576 7.61298 5.08128 7.46956C4.61087 7.18183 3.98764 6.79069 3.32667 6.36765L3.32437 6.36617C2.58225 5.8876 1.9705 5.50967 1.52818 5.25361C1.30566 5.1248 1.13588 5.03257 1.01853 4.97482C1.01575 4.97346 1.01302 4.97212 1.01035 4.97081C0.969281 4.9836 0.924162 5.00166 0.880191 5.02374C0.854931 5.03643 0.833101 5.04891 0.81496 5.06031C0.810294 5.08475 0.806511 5.10934 0.803894 5.13218C0.800805 5.15916 0.800046 5.17755 0.800046 5.18652H0.800115L0.800008 5.19548C0.800075 5.19548 0.800314 5.21133 0.802798 5.25158C0.805412 5.29393 0.809678 5.35057 0.815787 5.42224C0.827982 5.5653 0.846508 5.7565 0.870818 5.99088C0.919371 6.459 0.98974 7.0874 1.07528 7.82317C1.24629 9.29405 1.4769 11.1851 1.71225 13.062C1.9476 14.9389 2.18741 16.7996 2.3768 18.2097C2.47156 18.9152 2.55335 19.5054 2.61549 19.9277C2.64665 20.1395 2.67226 20.3049 2.6917 20.42C2.69427 20.4352 2.69668 20.4492 2.6989 20.4619C2.79922 20.4811 2.99202 20.5089 3.34107 20.5309C4.45065 20.6007 6.64713 20.6006 11.16 20.6003C11.4316 20.6003 11.7115 20.6003 12 20.6003C12.2885 20.6003 12.5684 20.6003 12.84 20.6003C17.3529 20.6006 19.5494 20.6007 20.6589 20.5309C21.008 20.5089 21.2008 20.4811 21.3011 20.4619C21.3033 20.4492 21.3057 20.4352 21.3083 20.42C21.3277 20.3049 21.3533 20.1395 21.3845 19.9277C21.4466 19.5054 21.5284 18.9152 21.6232 18.2097C21.8126 16.7996 22.0524 14.9389 22.2878 13.062C22.5231 11.1851 22.7537 9.29405 22.9247 7.82317C23.0103 7.0874 23.0806 6.459 23.1292 5.99088C23.1535 5.7565 23.172 5.5653 23.1842 5.42224C23.1903 5.35057 23.1946 5.29393 23.1972 5.25158C23.1994 5.21627 23.1998 5.19974 23.2 5.19622V5.18652C23.2 5.17755 23.1992 5.15916 23.1961 5.13218C23.1935 5.10934 23.1897 5.08475 23.185 5.06032C23.1669 5.04892 23.1451 5.03643 23.1198 5.02374C23.0758 5.00166 23.0307 4.98359 22.9897 4.97081C22.987 4.97212 22.9843 4.97346 22.9815 4.97482C22.8641 5.03257 22.6943 5.1248 22.4718 5.25361C22.0295 5.50967 21.4177 5.8876 20.6756 6.36617L20.6733 6.36765C20.0124 6.79069 19.3891 7.18183 18.9187 7.46956C18.6842 7.61299 18.4836 7.73327 18.3336 7.81963C18.2596 7.86225 18.191 7.90059 18.134 7.93032C18.1063 7.94473 18.0723 7.96186 18.0371 7.97751C18.0197 7.98523 17.9936 7.99637 17.9626 8.00737L17.9625 8.00742C17.9483 8.01245 17.9091 8.02636 17.8549 8.03801C17.5546 8.10431 17.3223 7.97846 17.2809 7.95604C17.2798 7.95542 17.2788 7.95488 17.2779 7.95442C17.1957 7.91031 17.1324 7.8599 17.0968 7.83007C17.0205 7.76615 16.9455 7.68877 16.8798 7.61721C16.743 7.46806 16.5668 7.25542 16.3572 6.99105C15.9347 6.45788 15.3355 5.66189 14.566 4.61536L14.5656 4.61487C13.9317 3.75133 13.3273 2.94689 12.8656 2.34594C12.6344 2.04504 12.4411 1.79791 12.2987 1.62091C12.2312 1.53695 12.1779 1.47225 12.1389 1.42648C12.1334 1.42457 12.1274 1.4226 12.1209 1.42064C12.0734 1.40627 12.028 1.40039 12 1.40039C11.972 1.40039 11.9266 1.40627 11.8791 1.42064C11.8726 1.4226 11.8666 1.42457 11.8611 1.42648C11.8221 1.47225 11.7688 1.53695 11.7013 1.62091C11.5589 1.79791 11.3656 2.04504 11.1344 2.34594C10.6727 2.94689 10.0683 3.75133 9.43437 4.61487ZM0.911075 4.92577C0.892076 4.91853 0.894796 4.9211 0.91385 4.92685C0.912848 4.92645 0.911923 4.9261 0.911075 4.92577ZM2.71901 20.5654C2.71903 20.565 2.71801 20.5602 2.71589 20.5522C2.71794 20.5617 2.71899 20.5657 2.71901 20.5654ZM21.281 20.5654C21.281 20.5657 21.2821 20.5617 21.2841 20.5522C21.282 20.5603 21.281 20.565 21.281 20.5654ZM23.0889 4.92577C23.0881 4.9261 23.0872 4.92646 23.0862 4.92685C23.1052 4.92111 23.1079 4.91852 23.0889 4.92577ZM14.2993 10.8095L14.2993 10.8094L14.3031 10.8137C14.7574 11.3246 15.0272 11.9337 15.0632 12.5846C15.0992 13.2348 14.8989 13.8701 14.5093 14.4301L14.5089 14.4307C13.3031 16.1602 10.6924 16.1401 9.49285 14.4332C8.93438 13.6391 8.79328 12.7975 9.06504 11.8875L9.06496 11.8875L9.06847 11.8763C9.6025 10.1791 11.596 9.28697 13.2273 10.0042L12.9053 10.7366L13.2263 10.0038C13.5866 10.1617 14.0333 10.5146 14.2993 10.8095Z"
                stroke="#4609F0"
                stroke-width="1.6"
              />
            </svg>
            {title}
          </p>
        ) : null}
        {vendre ? <p className={style.gratuit}>{t("Gratuit")}</p> : null}
        {offrepro ? null : <p className={style.title}>{t(title)}</p>}
        <p className={style.subText}>{t(text)}</p>
      </div>
      <div
        className={`${style.button} ${vendre || offrepro ? style.btnBlue : ""}` }
        onClick={() => {
          {
            reason === "Whatsapp"
              ? destinationUrl
                ? window.open(destinationUrl)
                : window.open(
                  `https://api.whatsapp.com/send?phone=${searchPayload.exclusivite
                    ? "+212664211141"
                    : "+212669793808"
                  }&text=${t(
                    searchPayload.exclusivite
                      ? "Bonjour, J'aimerais avoir plus d'informations concernant les exclusivités Agenz et le partage de commission"
                      : "Bonjour, J'ai un projet immobilier et je souhaiterai être accompagné"
                  )}%0a`
                )
              : (window.location.href = formatUrl(
                `/estimation-immobiliere`,
                lang
              ));
          }
        }}
      >
        {icon}
        <div
          data-tracking="click"
          data-value="help-annonce-whatsapp"
          className={style.button_text}
        >
          {btn_text}
        </div>
      </div>
    </div>
  );
}

export default index;
